import React, { createContext, useState } from "react";
import {
  GetNotEnrolledCoursesBySchoolDocument,
  GetEnrolledCoursesBySchoolDocument,
  useEnrollUserInCourseMutation,
  useMakeCoursePaymentMutation,
  useSchoolsQuery,
} from "../graphql/generated/graphql";
import { Platform } from "react-native";
import handleOpenLink from "../utils/handleOpenLink";

const CourseDetailsContext = createContext();

const defaultValues = {
  courseId: "",
  name: "",
  description: "",
  objectives: "",
  targetAudience: "",
  modules: [],
  cost: 0,
};

const CourseDetailsProvider = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [courseData, setCourseData] = useState(defaultValues);
  const { data: schoolsData } = useSchoolsQuery();

  const [createCheckoutSession, { loading: creatingPaymentSession }] = useMakeCoursePaymentMutation();
  const [enrollStudent, { loading: enrollingUserInCourse }] = useEnrollUserInCourseMutation({
    refetchQueries: [
      {
        query: GetEnrolledCoursesBySchoolDocument,
        variables: {
          schoolId: schoolsData?.getSchools[0]?.id,
        },
        skip: !schoolsData?.getSchools[0]?.id,
      },
      {
        query: GetNotEnrolledCoursesBySchoolDocument,
        variables: {
          schoolId: schoolsData?.getSchools[0]?.id,
        },
        skip: !schoolsData?.getSchools[0]?.id,
      },
    ],
  });

  const onEnroll = async (id, hasCost, callback) => {
    try {
      if (hasCost) {
        const response = await createCheckoutSession({
          variables: {
            courseId: id,
          },
        });

        const stripeUrl = response?.data?.createCheckoutSession?.url;

        if (!stripeUrl) {
          console.error("No Stripe URL returned from checkout session");
          throw new Error("Payment processing failed - no checkout URL");
        }

        if (Platform.OS === "web") {
          window.open(stripeUrl, "_blank");
        } else {
          await handleOpenLink(stripeUrl);
        }
      } else {
        await enrollStudent({
          variables: {
            courseId: id,
          },
        });
      }

      setIsVisible(false);
      setCourseData(defaultValues);

      if (typeof callback === "function") {
        callback();
      }
    } catch (error) {
      console.error("Enrollment error:", error);
    }
  };

  const loading = creatingPaymentSession || enrollingUserInCourse;

  return (
    <CourseDetailsContext.Provider
      value={{
        isVisible,
        setIsVisible,
        courseData,
        setCourseData,
        onEnroll,
        loading,
      }}>
      {children}
    </CourseDetailsContext.Provider>
  );
};

export { CourseDetailsContext, CourseDetailsProvider };
